import { useTranslation } from 'react-i18next'
import styles from './YearFilter.module.scss'

const YearFilter = ({ value, onChange, label, span = 9 }) => {
  const { t } = useTranslation('common')
  const finalLabel = label !== undefined ? label : t('reports.year_label')
  const currentYear = new Date().getFullYear()
  const years = []
  for (let y = currentYear; y >= currentYear - span; y -= 1) years.push(y)

  return (
    <div className={styles.wrap}>
      <label className={`unv-label ${styles.label}`}>{finalLabel}</label>
      <select
        className={`unv-select ${styles.select}`}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
      >
        {years.map((y) => (
          <option key={y} value={y}>
            {y}
          </option>
        ))}
      </select>
    </div>
  )
}

export default YearFilter
